import { render, staticRenderFns } from "./ProductDetailBrick.vue?vue&type=template&id=63ef8fa4&scoped=true&"
import script from "./ProductDetailBrick.vue?vue&type=script&lang=js&"
export * from "./ProductDetailBrick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ef8fa4",
  null
  
)

export default component.exports